var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__detail"},[_c('VueJsonPretty',{attrs:{"data":_vm.data,"deep":_vm.deep,"showLength":true,"showLine":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }